var PYU = {
  'toggle_username_password_visibility': function() {
    var password_input = document.getElementById('PYU_meta_userpw_field');
    if (password_input.type == 'password') {
      password_input.type = 'text';
    }
    else {
      password_input.type = 'password';
    }
  }
}